import { makeStyles, type Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatar: {
		background: theme.palette.primary.main,
		color: '#fff !important',
		fontWeight: 500,
	},
	title: {
		fontWeight: 500,
		fontSize: 20,
		color: '#394A61',
	},
}));

export default useStyles;
